module.exports = __webpack_public_path__ + "static/media/homework-card-footer.bbd2970c.png";